import React from "react";
import { Title, Text, Button } from "~/components/elements";

import * as S from "./styles";

import cnpj from "~/assets/img/cnpj-modelo.png";
import coupom from "~/assets/img/numero-cupom-modelo.png";
import companyName from "~/assets/img/razao-social-modelo.png";
import Exit from "~/assets/img/icon/modal-close.svg";
import ReactSVG from "react-svg";
import isMobile from "~/hooks/isMobile";

export default function QuestionModal({ questionName, handleModalQuestion }) {
  const mobile = isMobile();
  return (
    <S.Shade
      open={!!questionName}
      onClick={() => {
        handleModalQuestion(null);
      }}
    >
      <S.ModalBox
        open={!!questionName}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {!mobile && (
          <S.Exit onClick={() => handleModalQuestion(null)}>
            <ReactSVG wrapper="div" src={Exit} />
          </S.Exit>
        )}
        <S.TitleHolder>
          <Title level="6" primary>
            {questionName === "cnpj" && "CNPJ da loja"}
            {questionName === "company-name" && "Razão social"}
            {questionName === "coupon" && "Número do cupom fiscal"}
          </Title>
        </S.TitleHolder>

        <S.ContentModal>
          <S.ImgHolder>
            {questionName === "cnpj" && <img src={cnpj} alt="Modelo" />}
            {questionName === "company-name" && (
              <img src={companyName} alt="Modelo" />
            )}
            {questionName === "coupon" && <img src={coupom} alt="Modelo" />}
          </S.ImgHolder>

          <S.BgHolder>
            <S.BottomModal>
              {questionName === "coupon" && (
                <ul>
                  <li>
                    <Text>
                      <Text as="strong" primary>Cupom fiscal comum:</Text> são os
                      dígitos numéricos que aparecem ao lado de duas siglas:{" "}
                      <Text as="strong" className="list-strong">
                        COO
                      </Text>{" "}
                      ou{" "}
                      <Text as="strong" className="list-strong">
                        ECF.
                      </Text>
                    </Text>
                  </li>
                  <li>
                    <Text>
                      <Text as="strong" primary>Cupom fiscal eletrônico:</Text> é
                      identificado como{" "}
                      <Text as="strong" className="list-strong">
                        “Número do extrato”
                      </Text>{" "}
                      ou{" "}
                      <Text as="strong" className="list-strong">
                        “Número do SAT”.
                      </Text>
                    </Text>
                  </li>
                  <li>
                    <Text>
                      <Text as="strong" primary>Nota Fiscal DANFE:</Text> é o{" "}
                      <Text as="strong" className="list-strong">
                        Número
                      </Text>{" "}
                      e o{" "}
                      <Text as="strong" className="list-strong">
                        Número de Série
                      </Text>
                    </Text>
                  </li>
                </ul>
              )}

              {questionName === "cnpj" && (
                <S.ParagraphHolder>
                  <Text>
                    São os dígitos numéricos que aparecem ao lado da sigla{" "}
                    <Text as="strong">CNPJ</Text>
                  </Text>
                </S.ParagraphHolder>
              )}

              {questionName === "company-name" && (
                <S.ParagraphHolder>
                  <Text>
                    A razão social é o nome sob o qual a empresa se identifica
                    (no final pode ter as siglas EPP, EIRELI, LTDA, por
                    exemplo).
                  </Text>
                </S.ParagraphHolder>
              )}
            </S.BottomModal>
            <S.ButtonHolder>
              <Button color="primary" onClick={() => handleModalQuestion(null)}>
                OK, ENTENDI
              </Button>
            </S.ButtonHolder>
          </S.BgHolder>
        </S.ContentModal>
      </S.ModalBox>
    </S.Shade>
  );
}
